(() => {
  let attempts = 0;
  function initialize() {
  const banner = document.getElementById('YtCookieBanner');
  const dialog = document.getElementById('YtCookieDialog');
  const form = document.getElementById('YtCookieForm');
  const status = document.getElementById('YtCookieStatus');
  if (!banner || !dialog || !form || !window.Shopify?.loadFeatures) {
    if (++attempts < 60) window.setTimeout(initialize, 500);
    return;
  }
  window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
    if (error || !window.Shopify.customerPrivacy) return;
    const privacy = window.Shopify.customerPrivacy;
    document.querySelectorAll('[data-yt-cookie-open]').forEach(button => {
      button.hidden = false;
      button.addEventListener('click', () => {
        const consent = privacy.currentVisitorConsent();
        ['preferences', 'analytics', 'marketing'].forEach(key => form.elements[key].checked = consent[key] === 'yes');
        status.textContent = '';
        dialog.showModal();
      });
    });
    const consent = privacy.currentVisitorConsent();
    const pending = ['preferences', 'analytics', 'marketing'].every(key => !consent[key]);
    if (pending && privacy.shouldShowBanner() && !document.getElementById('shopify-pc__banner')) banner.hidden = false;
    function save(values) {
      const controls = [...dialog.querySelectorAll('button'), ...banner.querySelectorAll('button')];
      controls.forEach(button => button.disabled = true);
      let settled = false;
      const timeout = setTimeout(() => {
        if (settled) return;
        settled = true;
        controls.forEach(button => button.disabled = false);
        status.textContent = status.dataset.error;
        if (!dialog.open) dialog.showModal();
      }, 10000);
      try {
        privacy.setTrackingConsent(values, () => {
          if (settled) return;
          settled = true;
          clearTimeout(timeout);
          controls.forEach(button => button.disabled = false);
          banner.hidden = true;
          status.textContent = status.dataset.saved;
        });
      } catch {
        clearTimeout(timeout);
        settled = true;
        controls.forEach(button => button.disabled = false);
        status.textContent = status.dataset.error;
        if (!dialog.open) dialog.showModal();
      }
    }
    document.querySelectorAll('[data-yt-cookie-action]').forEach(button => button.addEventListener('click', () => {
      const allow = button.dataset.ytCookieAction === 'accept';
      save({preferences: allow, analytics: allow, marketing: allow});
    }));
    form.addEventListener('submit', event => {
      event.preventDefault();
      save({preferences: form.elements.preferences.checked, analytics: form.elements.analytics.checked, marketing: form.elements.marketing.checked});
    });
    document.getElementById('YtSaleOptOut').addEventListener('click', () => save({sale_of_data: false}));
    document.getElementById('YtCookieClose').addEventListener('click', () => dialog.close());
  });
  }
  initialize();
})();